import { useContext } from 'react';
import { isIntlToShapeLocation } from '@jutro/prop-types';
import { sanitizeUrl } from '@jutro/platform';
import { TranslatorContext } from '../TranslatorProvider';
export const getUrlTranslatorAndSanitizer = translator => (url, allowNoLeadingSlash = false) => {
  if (isIntlToShapeLocation(url)) {
    return {
      pathname: sanitizeUrl(translator(url.pathname), allowNoLeadingSlash),
      search: translator(url.search),
      hash: translator(url.hash),
      state: url.state
    };
  }
  return sanitizeUrl(translator(url), allowNoLeadingSlash);
};
export const useSafeTranslatedUrls = () => {
  const translator = useContext(TranslatorContext);
  return getUrlTranslatorAndSanitizer(translator);
};